import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateService } from '@ngx-translate/core';

import { PollParserInboxesStatisticsDto } from 'src/app/core/api/models';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { ParserStatsDoughnutChartComponent } from './charts/doughnut-chart/parser-stats-doughnut-chart.component';
import { ParserStatsPieChartComponent } from './charts/pie-chart/parser-stats-pie-chart.component';


@Component({
    selector: 'app-parser-stats',
    templateUrl: './parser-stats.component.html',
    styleUrls: ['./parser-stats.component.scss'],
    imports: [
        BaseIndexModule,
        MatFormFieldModule,
        MatInputModule,
        ParserStatsDoughnutChartComponent,
        ParserStatsPieChartComponent,
    ]
})
export class ParserStatsComponent implements OnInit {
  constructor(private translate: TranslateService) {}

  @Input() model: PollParserInboxesStatisticsDto;
  @Input() statType: 'survey' | 'competition';
  @Output('isClose') output_isClose = new EventEmitter<boolean>();

  pieChartId: string = 'parserStatsPieChart';
  doughnutChartId: string = 'parserStatsDoughnutChart';

  pieChartData: any[] = [];
  pieChartColors: string[] = [];
  pieChartLabels: string[] = [];

  doughnutChartData: any[] = [];
  doughnutChartColors: string[] = [];
  doughnutChartLabels: string[] = [];

  pageName = 'parserStats';
  title = this.translate.instant('common.statistics');

  ngOnInit() {
    this.setTitle();
    this.pieChartId += '_' + this.statType;
    this.doughnutChartId += '_' + this.statType;
  }

  onClose() {
    this.output_isClose.emit(true);
  }

  setTitle() {
    if (this.statType == 'survey') {
      this.title = this.translate.instant(
        'pages.pollParsers.stats.surveyStats'
      );
    } else if (this.statType == 'competition') {
      this.title = this.translate.instant(
        'pages.pollParsers.stats.competitionStats'
      );
    }
  }
}
